@if (form) {
  <mat-card>
    <app-card-header
      [title]="title"
      icono="schedule"
      [botonCerrar]="true"
      (cerrar)="dialogRef.close()"
    ></app-card-header>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <!-- Tipo de control -->
        <app-content-card title="Tipo de Control" icon="tune">
          <irx-segmentado formControlName="tipo" bloque>
            @for (tipo of tiposControlHorario; track tipo) {
              <irx-segmento [value]="tipo">
                <mat-icon>
                  {{ tipo === 'Apertura' ? 'lock_open' : 'lock' }}
                </mat-icon>
                {{ tipo }}
              </irx-segmento>
            }
          </irx-segmentado>
        </app-content-card>

        <!-- Días de la semana -->
        <app-content-card title="Días de la Semana" icon="date_range">
          <!-- Botones de selección rápida -->
          <div class="quick-select-buttons">
            <button
              irxBoton="secundario"
              tamano="compacto"
              type="button"
              (click)="seleccionarLunesViernes()"
            >
              <mat-icon>work</mat-icon>
              Lun-Vie
            </button>
            <button
              irxBoton="secundario"
              tamano="compacto"
              type="button"
              (click)="seleccionarSabadoDomingo()"
            >
              <mat-icon>weekend</mat-icon>
              Sáb-Dom
            </button>
            <button
              irxBoton="secundario"
              tamano="compacto"
              type="button"
              (click)="seleccionarTodosDias()"
            >
              <mat-icon>event_available</mat-icon>
              Todos
            </button>
            <button
              irxBoton="secundario"
              tamano="compacto"
              type="button"
              (click)="limpiarDias()"
            >
              <mat-icon>clear_all</mat-icon>
              Limpiar
            </button>
          </div>

          <!-- Selector de días -->
          <ng-select
            [items]="diasSemana"
            formControlName="dias"
            placeholder="Seleccioná los días"
            [multiple]="true"
            [searchable]="false"
            [closeOnSelect]="false"
            appendTo="body"
            required
            class="dias-select"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">
                {{ getNombreDiaConTilde(item) }}
              </span>
              <span
                class="ng-value-icon right irx-clickeable"
                role="button"
                tabindex="0"
                tooltip="Quitar"
                (click)="clear(item)"
                (keydown.enter)="clear(item)"
              >
                ×
              </span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ getNombreDiaConTilde(item) }}
            </ng-template>
          </ng-select>
        </app-content-card>

        <!-- Hora y Partición en una fila -->
        <app-content-card title="Hora y Partición" icon="access_time">
          <div class="form-row">
            <div class="flex-2">
              <app-time-picker formControlName="hora" [stepMinutes]="15" />
            </div>
            <div class="flex-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Partición</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="particion"
                  placeholder="Opcional"
                />
                <mat-icon matSuffix>tag</mat-icon>
                @if (form?.get('particion')?.hasError('pattern')) {
                  <mat-error>Solo números</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </app-content-card>

        <!-- Tolerancias -->
        <app-content-card title="Tolerancias (minutos)" icon="timer">
          <div class="tolerancias-container">
            <!-- Tolerancia Antes -->
            <div class="tolerancia-card">
              <div class="tolerancia-header">
                <mat-icon>arrow_back</mat-icon>
                <span>Antes</span>
              </div>
              <div class="tolerancia-content">
                <button
                  irxBotonIcono="borde"
                  tooltip="Restar 15 minutos"
                  tono="primario"
                  type="button"
                  (click)="decrementarToleranciaAntes()"
                  [disabled]="(form?.get('toleranciaAntes')?.value ?? 0) <= 0"
                >
                  <mat-icon>remove</mat-icon>
                </button>
                <div class="tolerancia-display">
                  <span class="tolerancia-value">
                    {{ form?.get('toleranciaAntes')?.value ?? 0 }}
                  </span>
                  <span class="tolerancia-unit">min</span>
                </div>
                <button
                  irxBotonIcono="borde"
                  tooltip="Sumar 15 minutos"
                  tono="primario"
                  type="button"
                  (click)="incrementarToleranciaAntes()"
                >
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>

            <!-- Tolerancia Después -->
            <div class="tolerancia-card">
              <div class="tolerancia-header">
                <span>Después</span>
                <mat-icon>arrow_forward</mat-icon>
              </div>
              <div class="tolerancia-content">
                <button
                  irxBotonIcono="borde"
                  tooltip="Restar 15 minutos"
                  tono="primario"
                  type="button"
                  (click)="decrementarToleranciaDespues()"
                  [disabled]="(form?.get('toleranciaDespues')?.value ?? 0) <= 0"
                >
                  <mat-icon>remove</mat-icon>
                </button>
                <div class="tolerancia-display">
                  <span class="tolerancia-value">
                    {{ form?.get('toleranciaDespues')?.value ?? 0 }}
                  </span>
                  <span class="tolerancia-unit">min</span>
                </div>
                <button
                  irxBotonIcono="borde"
                  tooltip="Sumar 15 minutos"
                  tono="primario"
                  type="button"
                  (click)="incrementarToleranciaDespues()"
                >
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- Error de validación de tolerancias -->
          @if (form?.hasError('alMenosUnaTolerancia')) {
            <div class="tolerancia-error">
              <mat-icon>warning</mat-icon>
              Al menos una tolerancia debe ser mayor a 0
            </div>
          }
        </app-content-card>
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
          Cancelar
        </button>
        <button
          irxBoton="principal"
          type="submit"
          [disabled]="!this.form.valid"
        >
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
}
